import React from 'react'
import './App.css';
import Routes from '../src/routes/index'

function App() {
  return (
    <div className="App">
        <Routes/>
    </div>
  );
}

export default App;
